import { render, staticRenderFns } from "./LawDeptlistRecieve.vue?vue&type=template&id=0d90c2d9&"
import script from "./LawDeptlistRecieve.vue?vue&type=script&lang=js&"
export * from "./LawDeptlistRecieve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports